export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14096.1842e5c7.jpg";